export default __webpack_public_path__ + "static/media/carousel-arrow-left.718a8e86.svg";